import Link from 'next/link';
import React from 'react';

export interface ExternalLinkProps extends Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'href' | 'target' | 'rel'
> {
  target?: string;
  href: string;
  rel?: string;
  disabled?: boolean;
}

// ExternalLink is a component that opens a link in the default browser. On
// desktop the hand-off is owned by the global handler in
// `src/tauri/externalLinkHandler.ts`, so this is a plain anchor either way.
export const ExternalLink = React.forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  (externalLinkProps, ref) => {
    const {
      disabled,
      href,
      children,
      className,
      target = '_blank',
      rel = 'noopener noreferrer',
      ...otherProps
    } = externalLinkProps;

    return (
      <Link
        ref={ref}
        href={href}
        target={target}
        rel={rel}
        className={className}
        aria-disabled={disabled}
        {...otherProps}
      >
        {children}
      </Link>
    );
  }
);

ExternalLink.displayName = 'ExternalLink';
